import { number } from "./../types/number";

export default function greaterThan(a, b) {
  a = number(a);
  b = number(b);
  return a > b;
}
